/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'primaryarrow': {
    width: 11,
    height: 7,
    viewBox: '0 0 11 7',
    data: '<path pid="0" d="M.51.483a.577.577 0 0 0 .114.362l4.617 6.007c.07.092.166.145.266.147.102 0 .2-.053.271-.147L10.395.845a.603.603 0 0 0 .007-.697.343.343 0 0 0-.273-.15H.896C.686-.005.514.21.51.484z" _fill="#1FCD93" fill-rule="evenodd"/>'
  }
})
